import QRCode from 'react-qr-code'
import { Text } from '@/components'
import AppStoreButton from '@/app/components/AppStoreButton/AppStoreButton'
import ConfigureDeviceStepBody from '../components/ConfigureDeviceStepBody'
import useConfigureMobilePushNotificationsViewModel from './ConfigureMobilePushNotifications.viewmodel'

export default function ConfigureMobilePushNotifications() {
  const { qrUrl } = useConfigureMobilePushNotificationsViewModel()

  return (
    <ConfigureDeviceStepBody>
      <div className="flex flex-col items-center gap-6 text-center">
        <div className="flex flex-col gap-2">
          <Text variant="h2" align="center">
            Lastly, download our mobile app!
          </Text>
          <Text variant="body3" align="center">
            Download the app to receive up to date notifications on program
            events and the best Optiwatt experience
          </Text>
        </div>
        <div className="p-4 bg-white rounded-lg">
          <QRCode value={qrUrl} size={180} />
        </div>
        <div className="flex gap-2 w-full">
          <AppStoreButton store="apple" className="flex-1" />
          <AppStoreButton store="google" className="flex-1" />
        </div>
      </div>
    </ConfigureDeviceStepBody>
  )
}
